module.exports = __webpack_public_path__ + "img/Background_blue.1f5c5b10.png";